// import React, { useEffect, useState } from "react";
// import { Paper, Typography, TablePagination, FormControl, InputLabel, Select, MenuItem, IconButton, CircularProgress, Box } from "@mui/material";
// import DownloadIcon from '@mui/icons-material/Download';
// import axios from "axios";
// import Table from "../Table/Table";

// const ViewUpload = () => {
//   const [uploadedFiles, setUploadedFiles] = useState([]);
//   const [filteredFiles, setFilteredFiles] = useState([]);
//   const [page, setPage] = useState(0);
//   const [rowsPerPage, setRowsPerPage] = useState(5);
//   const [order, setOrder] = useState("desc");
//   const [orderBy, setOrderBy] = useState("last_modified");
//   const [filterType, setFilterType] = useState("All");
//   const [loading, setLoading] = useState(true); // New loading 
//   const baseURL = process.env.REACT_APP_API_BASE_URL;

//   const tableHeaders = [
//     { dbParam: "index", displayName: "Sr. No." },
//     { dbParam: "supplierName", displayName: "Supplier Name" },
//     { dbParam: "name", displayName: "Uploaded File Name" },
//     { dbParam: "dataType", displayName: "Data Type" },
//     { dbParam: "last_modified", displayName: "Last Modified" },
//     { dbParam: "download", displayName: "Download" },
//   ];

//   useEffect(() => {
//     const fetchUploadedFiles = async () => {
//       const projectId = localStorage.getItem("selectedProject");
//       if (!projectId) {
//         console.error("No projectId found in local storage.");
//         setLoading(false); // Stop loading if no projectId
//         return;
//       }

//       try {
//         setLoading(true); // Start loading
//         const response = await axios.get(
//           `${baseURL}get_file_names?projectId=${projectId}`
//         );
//         const data = response.data;

//         let processedFiles = [];
//         if (data.projectId === projectId) {
//           Object.keys(data.suppliers).forEach((supplierName) => {
//             const { flash_files: flashFiles, pdi_files: pdiFiles, packing_files: packingFiles, el_files: elFiles } = data.suppliers[supplierName];

//             flashFiles.forEach((file) => {
//               processedFiles.push({
//                 supplierName,
//                 name: file.file_path.split("/").pop(),
//                 dataType: "Flash",
//                 last_modified: file.last_modified,
//                 download_url: file.download_url,
//               });
//             });

//             pdiFiles.forEach((file) => {
//               processedFiles.push({
//                 supplierName,
//                 name: file.file_path.split("/").pop(),
//                 dataType: "PDI",
//                 last_modified: file.last_modified,
//                 download_url: file.download_url,
//               });
//             });

//             packingFiles.forEach((file) => {
//               processedFiles.push({
//                 supplierName,
//                 name: file.file_path.split("/").pop(),
//                 dataType: "Packing List",
//                 last_modified: file.last_modified,
//                 download_url: file.download_url,
//               });
//             });

//             elFiles.forEach((file) => {
//               processedFiles.push({
//                 supplierName,
//                 name: file.file_path.split("/").pop(),
//                 dataType: "EL",
//                 last_modified: file.last_modified,
//                 download_url: file.download_url,
//               });
//             });
//           });
//         }

//         processedFiles = processedFiles.sort((a, b) => new Date(b.last_modified) - new Date(a.last_modified));
//         processedFiles = processedFiles.map((file, index) => ({
//           ...file,
//           index: index + 1,
//         }));

//         setUploadedFiles(processedFiles);
//         setFilteredFiles(processedFiles);
//       } catch (error) {
//         console.error("Error fetching uploaded files:", error);
//       } finally {
//         setLoading(false); // Stop loading after fetch completes or fails
//       }
//     };

//     fetchUploadedFiles();
//   }, []);

//   const handleFilterChange = (event) => {
//     const selectedType = event.target.value;
//     setFilterType(selectedType);
//     setPage(0);

//     if (selectedType === "All") {
//       setFilteredFiles(uploadedFiles);
//     } else {
//       const filtered = uploadedFiles.filter((file) => file.dataType === selectedType);
//       setFilteredFiles(filtered);
//     }
//   };

//   const handleSort = (property) => {
//     if (property === "download") return;
//     const isAsc = orderBy === property && order === "asc";
//     setOrder(isAsc ? "desc" : "asc");
//     setOrderBy(property);

//     const sortedFiles = [...filteredFiles].sort((a, b) => {
//       const valA = a[property];
//       const valB = b[property];
//       if (property === "last_modified") {
//         return isAsc
//           ? new Date(valA) - new Date(valB)
//           : new Date(valB) - new Date(valA);
//       }
//       return isAsc ? (valA < valB ? -1 : 1) : (valA > valB ? -1 : 1);
//     });

//     setFilteredFiles(sortedFiles);
//   };

//   const handleChangePage = (event, newPage) => {
//     setPage(newPage);
//   };

//   const handleChangeRowsPerPage = (event) => {
//     setRowsPerPage(parseInt(event.target.value, 10));
//     setPage(0);
//   };

//   const handleDownload = (downloadUrl) => {
//     window.open(downloadUrl, "_blank");
//   };

//   return (
//     <Paper elevation={3} style={{ padding: "16px" }}>
//       {loading ? (
//         <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
//           <CircularProgress />
//         </Box>
//       ) : (
//         <>
//           <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
//             <Typography variant="h6">Uploaded Files</Typography>
//             <FormControl style={{ minWidth: 150 }}>
//               <InputLabel>Data Type</InputLabel>
//               <Select value={filterType} onChange={handleFilterChange} label="Data Type">
//                 <MenuItem value="All">All</MenuItem>
//                 <MenuItem value="Flash">Flash</MenuItem>
//                 <MenuItem value="PDI">PDI</MenuItem>
//                 <MenuItem value="Packing List">Packing List</MenuItem>
//                 <MenuItem value="EL">EL</MenuItem>
//               </Select>
//             </FormControl>
//           </div>
//           <Table
//             tableHeaders={tableHeaders}
//             tableData={filteredFiles.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((file) => ({
//               ...file,
//               download: (
//                 <IconButton
//                   color="primary"
//                   sx={{
//                     color: '#424752',
//                     '&:hover': { color: '#6c757d' },
//                   }}
//                   onClick={() => handleDownload(file.download_url)}
//                 >
//                   <DownloadIcon />
//                 </IconButton>
//               ),
//             }))}
//             order={order}
//             orderBy={orderBy}
//             handleSort={handleSort}
//             handleEditClick={() => {}}
//           />
//           <TablePagination
//             rowsPerPageOptions={[5, 10, 25]}
//             component="div"
//             count={filteredFiles.length}
//             rowsPerPage={rowsPerPage}
//             page={page}
//             onPageChange={handleChangePage}
//             onRowsPerPageChange={handleChangeRowsPerPage}
//           />
//         </>
//       )}
//     </Paper>
//   );
// };

// export default ViewUpload;

import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  TablePagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  IconButton,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import DownloadIcon from '@mui/icons-material/Download';
import DeleteIcon from '@mui/icons-material/Delete';
import apiClient from "../../pages/keycloak/axiosInstance";
import Table from "../Table/Table";

const ViewUpload = () => {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [order, setOrder] = useState("desc");
  const [orderBy, setOrderBy] = useState("last_modified");
  const [filterType, setFilterType] = useState("All");
  const [loading, setLoading] = useState(true);

  // Modal states
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deletingFile, setDeletingFile] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  // Snackbar state
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "error", // "error" | "success" | "warning" | "info"
  });

  const showSnackbar = (message, severity = "error") => {
    setSnackbar({ open: true, message, severity });
  };

  const closeSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // Role check
  const userRoles = (() => {
    const storedRoles = sessionStorage.getItem("userRoles");
    let roles = [];
    if (storedRoles) {
      try {
        const parsed = JSON.parse(storedRoles);
        if (Array.isArray(parsed)) roles = parsed;
      } catch {
        roles = storedRoles.split(",").map(r => r.trim());
      }
    }
    return roles;
  })();

  const hasDeletePermission = userRoles.includes("MT_Upload_Delete");

  const dataTypeToOption = {
    "Flash": "flash",
    "PDI": "pdi",
    "Packing List": "packing",
    "EL": "el",
  };

  const tableHeaders = [
    { dbParam: "index", displayName: "Sr. No." },
    { dbParam: "supplierName", displayName: "Supplier Name" },
    { dbParam: "name", displayName: "Uploaded File Name" },
    { dbParam: "dataType", displayName: "Data Type" },
    { dbParam: "last_modified", displayName: "Last Modified" },
    { dbParam: "download", displayName: "Action" },
  ];

  const loadUploadedFiles = async () => {
    const projectId = localStorage.getItem("selectedProject");
    if (!projectId) {
      console.error("No projectId found in local storage.");
      setLoading(false);
      return;
    }

    const allowedSuppliers = userRoles
      .filter(role => role.startsWith(`${projectId}_`) && role.endsWith("_view"))
      .map(role => role.slice(projectId.length + 1, -5))
      .filter(name => name.length > 0);

    const shouldFilter = userRoles.length > 0;

    try {
      setLoading(true);
      const response = await apiClient.get(`get_file_names?projectId=${projectId}`);
      const data = response.data;

      let processedFiles = [];
      if (data.projectId === projectId) {
        Object.keys(data.suppliers).forEach((supplierName) => {
          if (shouldFilter && !allowedSuppliers.includes(supplierName)) return;

          const { flash_files: flashFiles, pdi_files: pdiFiles, packing_files: packingFiles, el_files: elFiles } = data.suppliers[supplierName];

          const addFiles = (files, dataType) => {
            files.forEach((file) => {
              processedFiles.push({
                supplierName,
                name: file.file_path.split("/").pop(),
                dataType,
                last_modified: file.last_modified,
                download_url: file.download_url,
              });
            });
          };

          addFiles(flashFiles, "Flash");
          addFiles(pdiFiles, "PDI");
          addFiles(packingFiles, "Packing List");
          addFiles(elFiles, "EL");
        });
      }

      processedFiles = processedFiles
        .sort((a, b) => new Date(b.last_modified) - new Date(a.last_modified))
        .map((file, index) => ({ ...file, index: index + 1 }));

      setUploadedFiles(processedFiles);
      setFilteredFiles(processedFiles);
    } catch (error) {
      console.error("Error fetching uploaded files:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadUploadedFiles();
  }, []);

  const handleFilterChange = (event) => {
    const selectedType = event.target.value;
    setFilterType(selectedType);
    setPage(0);
    setFilteredFiles(
      selectedType === "All"
        ? uploadedFiles
        : uploadedFiles.filter((file) => file.dataType === selectedType)
    );
  };

  const handleSort = (property) => {
    if (property === "download") return;
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);

    const sortedFiles = [...filteredFiles].sort((a, b) => {
      const valA = a[property], valB = b[property];
      if (property === "last_modified") {
        return isAsc ? new Date(valA) - new Date(valB) : new Date(valB) - new Date(valA);
      }
      return isAsc ? (valA < valB ? -1 : 1) : (valA > valB ? -1 : 1);
    });

    setFilteredFiles(sortedFiles);
  };

  const handleChangePage = (_, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDownload = (downloadUrl) => window.open(downloadUrl, "_blank");

  const openDeleteModal = (file) => {
    setDeletingFile(file);
    setShowDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setShowDeleteModal(false);
    setDeletingFile(null);
  };

  const confirmDelete = async () => {
    if (!deletingFile || isDeleting) return;

    const projectId = localStorage.getItem("selectedProject");
    if (!projectId) {
      showSnackbar("No project selected.");
      closeDeleteModal();
      return;
    }

    const selected_option = dataTypeToOption[deletingFile.dataType];
    if (!selected_option) {
      showSnackbar("Unknown file type. Cannot delete.");
      closeDeleteModal();
      return;
    }

    setIsDeleting(true);
    try {
      await apiClient.post(`delete-upload`, {
        project_id: projectId,
        supplier_name: deletingFile.supplierName,
        selected_option,
        file_name: deletingFile.name,
      });

      await loadUploadedFiles();
      closeDeleteModal();
      showSnackbar("File deleted successfully.", "success");
    } catch (error) {
      console.error("Error deleting file:", error);

      // ✅ Extract message from API response, fallback gracefully
      const apiMessage =
        error.response?.data?.message ||
        error.response?.data?.detail ||
        error.response?.data?.error ||
        (typeof error.response?.data === "string" ? error.response.data : null) ||
        "Failed to delete the file. Please try again later.";

      showSnackbar(apiMessage, "error");
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Paper elevation={3} sx={{ p: 2 }}>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="300px">
          <CircularProgress />
        </Box>
      ) : (
        <>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h6">Uploaded Files</Typography>
            <FormControl sx={{ minWidth: 150 }}>
              <InputLabel>Data Type</InputLabel>
              <Select value={filterType} onChange={handleFilterChange} label="Data Type">
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Flash">Flash</MenuItem>
                <MenuItem value="PDI">PDI</MenuItem>
                <MenuItem value="Packing List">Packing List</MenuItem>
                <MenuItem value="EL">EL</MenuItem>
              </Select>
            </FormControl>
          </Box>

          <Table
            tableHeaders={tableHeaders}
            tableData={filteredFiles
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((file) => ({
                ...file,
                download: (
                  <Box display="flex" gap={0} justifyContent="center">
                    <IconButton
                      sx={{ color: '#424752', '&:hover': { color: '#6c757d' } }}
                      onClick={() => handleDownload(file.download_url)}
                    >
                      <DownloadIcon />
                    </IconButton>
                    {hasDeletePermission && (
                      <IconButton
                        sx={{ color: '#424752', '&:hover': { color: '#dc3545' } }}
                        onClick={() => openDeleteModal(file)}
                        title="Delete File"
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </Box>
                ),
              }))}
            order={order}
            orderBy={orderBy}
            handleSort={handleSort}
            handleEditClick={() => {}}
          />

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={filteredFiles.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}

      {/* Delete Confirmation Modal */}
      <Dialog open={showDeleteModal} onClose={closeDeleteModal} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', color: 'error.main' }}>
          <DeleteIcon sx={{ mr: 1 }} />
          Confirm File Deletion
        </DialogTitle>
        <DialogContent>
          <DialogContentText sx={{ fontSize: '1.1rem', mb: 2 }}>
            Are you sure you want to <strong>permanently delete</strong> this file?
          </DialogContentText>
          {deletingFile && (
            <>
              <DialogContentText sx={{ fontWeight: 'bold', mb: 1 }}>
                File Name: {deletingFile.name}
              </DialogContentText>
              <DialogContentText>
                Supplier: <strong>{deletingFile.supplierName}</strong><br />
                Data Type: <strong>{deletingFile.dataType}</strong>
              </DialogContentText>
            </>
          )}
          <DialogContentText sx={{ mt: 3, color: 'error.main', fontWeight: 'bold' }}>
            This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={closeDeleteModal} disabled={isDeleting}>Cancel</Button>
          <Button
            onClick={confirmDelete}
            color="error"
            variant="contained"
            disabled={isDeleting}
            startIcon={isDeleting ? <CircularProgress size={20} /> : null}
          >
            {isDeleting ? "Deleting..." : "Delete Permanently"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ✅ Error/Success Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={closeSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={closeSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default ViewUpload;